import React from 'react';
import FormRow from "../../../../Components/HorizontalForm/FormRow";
import { getRecurrenceDescription } from "../../../../Helpers/DateTimeHelper";
import RecurrenceManagementFormProvider from "../../../../Components/Forms/Recurrence/RecurrenceManagementFormProvider";
import RecurrenceManagementToggleModal from "../../../../Components/Forms/Recurrence/RecurrenceManagementToggleModal";

const BookingFormRecurrence = ({booking, bookingConfig, onBookingFormChange}) => {

    if (!bookingConfig.recurring_bookings) {
        return null;
    }

    return (<>
        <FormRow>
            <RecurrenceManagementFormProvider
                booking={booking}
                bookingConfig={bookingConfig}
                onBookingFormChange={onBookingFormChange}
            >
                {(booking.id && booking.recurrence && booking.recurrence.repeats) && (
                    <div>
                        You are editing a single occurrence of a booking series which occurs
                        {getRecurrenceDescription(booking.recurrence, '')}
                    </div>
                )}

                {(!booking.id) && (
                    <RecurrenceManagementToggleModal/>
                )}
            </RecurrenceManagementFormProvider>
        </FormRow>
    </>);
};

BookingFormRecurrence.propTypes = {};

BookingFormRecurrence.defaultProps = {};

export default BookingFormRecurrence;
